import { AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';

/* this special directive removes the wrapping angular html element which causes web component issues with leaf in certain instaces where they expect child/parent structure to follow a set format */

@Directive()
export class LeafAngularWrapper implements AfterViewInit {
  constructor(public renderer: Renderer2, public elRef: ElementRef) {}

  ngAfterViewInit() {
    // access the DOM. get the element to unwrap
    const el = this.elRef.nativeElement; // component selector
    const parent = this.renderer.parentNode(this.elRef.nativeElement); // parent

    // move children to parent (everything is moved including comments which angular depends on)
    while (el.firstChild) {
      // this line doesn't work with server-rendering
      this.renderer.appendChild(parent, el.firstChild);
    }

    // remove empty element from parent - true to signal that this removed element is a host element
    this.renderer.removeChild(parent, el, true);
  }
}
